import { isDatasetFalsy } from '@peckadesign/pd-naja'
import { Fragment, ReactNode } from 'jsx-dom'
import * as React from 'jsx-dom'
import { ConditionalWrappers } from '@/js/helpers/JSXConditionalWrappers'

export interface SpinnerProps {
	overlay?: boolean
	size?: number
	sticky?: boolean
}

export const Spinner = ({ overlay = false, size = 50, sticky = true }: SpinnerProps): Element => {
	return (
		<span
			className={{
				'spinner flex flex-column items-center justify-center box-content text-center': true,
				'spinner--overlay absolute inset-0 z-spinner rounded-inherit': overlay,
				'my-5': !overlay
			}}
			aria-label="Načítání…"
		>
			<ConditionalWrappers
				wrappers={[
					overlay &&
						sticky &&
						((children: ReactNode) => (
							<span className="spinner__sticky sticky block h-0 inset-y-[50vh]">{children}</span>
						)),
					overlay && sticky && ((children: ReactNode) => <span className="block -translate-y-1/2">{children}</span>)
				]}
			>
				<Fragment>
					<svg
						aria-hidden="true"
						width={size}
						height={size}
						className="spinner__spinner shrink-0 overflow-hidden text-gray-200"
						viewBox="0 0 100 100"
						xmlns="http://www.w3.org/2000/svg"
					>
						<circle cx="50" cy="50" r="45" stroke="currentColor" fill="none" stroke-width="10"></circle>
						<circle
							cx="50"
							cy="50"
							r="45"
							fill="none"
							stroke="currentColor"
							stroke-width="10"
							stroke-dasharray="64 300"
							stroke-linecap="round"
							className="animate-spin origin-center text-blue-500"
						></circle>
					</svg>
				</Fragment>
			</ConditionalWrappers>
		</span>
	)
}

export const getSpinnerProps = (element: Element): SpinnerProps => {
	const spinnerSize = element.getAttribute('data-naja-spinner-size')
	const spinnerSticky = !isDatasetFalsy(element, 'najaSpinnerSticky')

	return {
		overlay: true,
		size: spinnerSize ? parseInt(spinnerSize) : undefined,
		sticky: spinnerSticky
	}
}

export const getNonStickySpinnerProps = (element: Element): SpinnerProps => {
	const spinnerSize =
		element.getAttribute('data-naja-btn-spinner-size') || element.getAttribute('data-naja-spinner-size')
	const spinnerOverlay = !isDatasetFalsy(element, 'najaSpinnerOverlay')

	return {
		overlay: spinnerOverlay,
		size: spinnerSize ? parseInt(spinnerSize) : 24,
		sticky: false
	}
}
